import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid } from '@material-ui/core';
import { Cancel, Done } from '@material-ui/icons';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
import { FormikTextFieldComponent } from 'components/Field';

interface IProps {
  title: string;
  disabled: boolean;
  onSubmitAgreement(comment: string): void;
  onClose(): void;
}

const CancelAgreementDialog: React.FC<IProps & DialogProps> = ({
  open,
  title,
  disabled,
  onSubmitAgreement,
  onClose,
}) => {
  const initialValues = {
    comment: '',
  };

  const validationSchema = yup.object().shape({
    comment: yup.string(),
  });

  const handleSubmitAgreement = ({ comment }: { comment: string }) => {
    onSubmitAgreement(comment);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="body">
      <DialogTitle>
        <b>{title}</b>
      </DialogTitle>

      <Formik
        onSubmit={handleSubmitAgreement}
        validationSchema={validationSchema}
        initialValues={initialValues}
        enableReinitialize
      >
        {() => (
          <Form>
            <DialogContent dividers>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Field
                    name="comment"
                    label="Комментарий"
                    fullWidth
                    disabled={disabled}
                    component={FormikTextFieldComponent}
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button variant="contained" disabled={disabled} onClick={onClose} startIcon={<Cancel />}>
                Отменить
              </Button>

              <Button color="primary" variant="contained" disabled={disabled} type="submit" startIcon={<Done />}>
                Применить
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default CancelAgreementDialog;
